import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "size", "view", "children", "tagName", "icon"];
import React from 'react';
import { cnBem, forwardRefWithTag } from '@carnica/utils';
import { Text } from "../Text";
import { colorMap, contentSizeMap, iconColorMap } from "./utils";
import styles from "./styles.pcss";
var cnTag = cnBem('tag', styles);
export var Tag = forwardRefWithTag(function (props, ref) {
  var className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 's' : _props$size,
    _props$view = props.view,
    view = _props$view === void 0 ? 'light' : _props$view,
    children = props.children,
    _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'div' : _props$tagName,
    Icon = props.icon,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Text, _extends({}, otherProps, {
    className: cnTag({
      size: size,
      view: view,
      tagName: tagName
    }, [className]),
    color: colorMap[view],
    ref: ref,
    tagName: tagName,
    variant: contentSizeMap[size],
    "data-t-id": "components-Tag"
  }), Icon && /*#__PURE__*/React.createElement(Icon, {
    color: iconColorMap[view],
    size: size === 's' ? 'xs' : 's'
  }), children);
});